import React, { memo, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { Icon } from '@atlas/ui';

const TournamentHeaderView = ({ backPath, categoryName, sportName, tournament }) => {
  const { push } = useHistory();

  const goBack = useCallback(
    event => {
      event.preventDefault();
      push(backPath);
    },
    [backPath, push],
  );

  if (!tournament) {
    return null;
  }

  return (
    <div className="tournament-page-header">
      <Link onClick={goBack} to={backPath}>
        <div className="back-button">
          <Icon name="back" />
        </div>
      </Link>
      <div className="tournament-page-header-labels">
        <div className="tournament-page-header-parents">
          {sportName} / {categoryName}
        </div>
        <div className="tournament-page-header-label">{tournament.name}</div>
      </div>
    </div>
  );
};

export default memo(TournamentHeaderView);
